module.exports = __webpack_public_path__ + "static/media/sidebar-2.d1035962.jpg";